// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bdebfba9","977":"d0e2fbe2"}[chunkId] + ".chunk.js";
};